import { PATH_AUTH } from "../routes/paths";

const isValidToken = () => {
  let a = true;
  const expiresIn = parseInt(localStorage.getItem("expiresIn"));
  const now = new Date();
  const currentUnixSeconds = Math.round(now.getTime() / 1000);
  if (currentUnixSeconds >= expiresIn) {
    a = false;
  }
  return a;
};

const handleTokenExpired = (exp) => {
  let expiredTimer;

  const currentTime = Date.now();

  // Test token expires after 10s
  // const timeLeft = currentTime + 10000 - currentTime; // ~10s
  const timeLeft = exp * 1000 - currentTime;

  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(() => {
    // eslint-disable-next-line no-alert
    alert("Token expired");

    localStorage.removeItem("accessToken");

    window.location.href = PATH_AUTH.login;
  }, timeLeft);
};

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem("tokenType", accessToken.tokenType);
    localStorage.setItem("accessToken", accessToken.accessToken);
    localStorage.setItem("refreshToken", accessToken.refreshToken);
    localStorage.setItem("expiresIn", accessToken.expiresIn);
  } else {
    window.location.reload();
    // delete axios.defaults.headers.common.Authorization;
  }
};

export { isValidToken, setSession };
